<template>
  <!--

  .btn--vetical-header-hidden 클릭시 vertical-type-a과 vertical--main에 hidden--header 추가

  -->
  <div class="position--relative">
    <horizontal-type-e
      class="header-horizontal-type-e style--border spacing--md white w--100% box-sizing position--fixed z--10 box-shadow--sm"
      @clickVerticalHeaderBtn="toggle"
    >
    </horizontal-type-e>
    <vertical-type-a
      class="header-vertical-type-a pt--90px hidden--logo gray lighten-5"
      :class="hiddenClass"
    ></vertical-type-a>
    <div
      class="vertical--main"
      :class="hiddenClass"
    >
      <slot></slot>
      <footer-type-c></footer-type-c>
    </div>
  </div>
</template>

<script>
import toggle from '@/component/js/toggle'

export default {
  mixins: [toggle],
  computed: {
    hiddenClass () {
      return this.toggleStatus.isShow ? '' : 'hidden--header'
    }
  },
  mounted () {
    this.toggleStatus.isShow = true
  },
  components: {
    HorizontalTypeE: () => import('@/component/layout/header/horizontal/TypeE'),
    VerticalTypeA: () => import('@/component/layout/header/vertical/TypeA'),
    FooterTypeC: () => import('@/component/layout/footer/TypeC')
  }
}
</script>
